export const emptyFeatureCollection = {
  type: "FeatureCollection",
  features: []
} as GeoJSON.FeatureCollection;
